import { User } from 'models/User/User';

export const initialUser: User = {
    id: 0,
    primaryEmail: 'Default',
    creationSource: 'Default',
};
